import ModalStickyBottom from '../modal-sticky-bottom/ModalStickyBottom';
import { SectionTitle } from '../typography/Heading';
import styles from './scrollable-modal-sticky-bottom.module.less';

export const ScrollableModalStickyBottom = ({
    title,
    isOpen,
    onModalClose,
    footerComponent,
    children,
    footerWrapperClass = '',
    wrapperClass = '',
    contentWrapperClass = '',
    ...props
}) => {
    return (
        <ModalStickyBottom
            className={[styles.wrapper, wrapperClass].join(' ')}
            containerClassName={styles.wrapperContainer}
            isOpen={isOpen}
            onRequestClose={onModalClose}
            {...props}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <SectionTitle className={styles.title}>{title}</SectionTitle>
                </div>
                <div className={[styles.mainContentWrapper, contentWrapperClass].join(' ')}>{children}</div>
                {footerComponent && (
                    <div className={[styles.footer, footerWrapperClass].join(' ')}>{footerComponent}</div>
                )}
            </div>
        </ModalStickyBottom>
    );
};
